import React from "react";

import styles from "./LoadingSpinner.module.scss";

const LoadingSpinner = () => (
  <div className={styles.spinLoaderContainer}>
    <div className={styles.spinner} />
  </div>
);

export default LoadingSpinner;
